/**
 * Discharge Module — Shared Components
 * Re-exports ErrorBoundary and withErrorBoundary from Power Reporting shared module,
 * plus shared UI primitives used across discharge components.
 */
export { default as ErrorBoundary, withErrorBoundary } from '../../powerreporting/components/shared/ErrorBoundary';

/**
 * StatusFilterPills — reusable pill-style filter bar for status-based filtering.
 * Used in PowerSelectionTable and DischargeHistoryTable.
 *
 * @param {{ key: string, label: string }[]} options - Filter option definitions
 * @param {string} activeFilter - Currently active filter key
 * @param {(key: string) => void} onFilterChange - Handler called on selection
 * @param {Record<string, number>} counts - Count per filter key
 */
export const StatusFilterPills = ({ options, activeFilter, onFilterChange, counts }) => (
  <div className="flex flex-wrap items-center gap-1.5 qhd:gap-2">
    {options.map(({ key, label }) => {
      const isActive = activeFilter === key;
      const count = counts[key] ?? 0;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onFilterChange(key)}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 qhd:px-4 qhd:py-2 text-xs qhd:text-sm font-semibold rounded-full border transition-all duration-200 ${
            isActive
              ? 'bg-primary text-white border-primary shadow-sm'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-primary/60 hover:text-primary dark:hover:text-primary-light'
          }`}
        >
          {label}
          {key !== 'all' && count > 0 && (
            <span className={`text-[10px] qhd:text-xs font-bold ${
              isActive ? 'text-white/80' : 'text-gray-400 dark:text-gray-500'
            }`}>
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
